import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "form-floating mb-4" }
const _hoisted_3 = { for: "uiCurrentValue" }
const _hoisted_4 = { class: "my-3 text-danger" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
const _hoisted_6 = { class: "form-floating" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Payable from:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " How much in total (including any employers contribution) is currently being paid in each month? ", -1)
const _hoisted_10 = { class: "form-floating" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Total monthly amount", -1)
const _hoisted_13 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yes_no_question = _resolveComponent("yes-no-question")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        ref: "uiCurrentValue",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentValue) = $event)),
        onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValidator.checkNumeric($event))),
        class: "form-control",
        placeholder: "Current value of pot"
      }, null, 544), [
        [_vModelText, _ctx.currentValue]
      ]),
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.currentValueLabel), 1)
    ]),
    _withDirectives(_createElementVNode("p", _hoisted_4, [
      _hoisted_5,
      _createTextVNode(" Current value not valid. ")
    ], 512), [
      [_vShow, _ctx.showValidation]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("select", {
        ref: "payableFrom",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPayableFromYear) = $event)),
        class: "form-select w-50"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getYearsPayableFrom(), (item) => {
          return (_openBlock(), _createElementBlock("option", {
            key: item,
            value: item
          }, _toDisplayString(item), 9, _hoisted_7))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.selectedPayableFromYear]
      ]),
      _hoisted_8
    ], 512), [
      [_vShow, _ctx.capturePayableFrom]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_yes_no_question, {
        ref: "intendToMakeContribs",
        name: "intendToMakeContribs",
        text: "Do you (and possibly your employer) intend to make contributions?",
        onAnswerChanged: _ctx.onIntendToMakeContribsAnswerChanged
      }, null, 8, ["onAnswerChanged"]),
      _createElementVNode("div", {
        class: _normalizeClass(["animated", [_ctx.showContribDetail ? 'fadeIn' : '']])
      }, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("input", {
            ref: "monthlyContribValue",
            type: "text",
            onKeypress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputValidator.checkNumeric($event))),
            class: "form-control",
            value: _ctx.monthlyFutureContrib,
            placeholder: "Total monthly amount"
          }, null, 40, _hoisted_11),
          _hoisted_12
        ]),
        _createVNode(_component_yes_no_question, {
          ref: "willIncreaseContribs",
          name: "willIncreaseContribs",
          text: "Will these increase if your salary goes up?"
        }, null, 512)
      ], 2)
    ], 512), [
      [_vShow, !_ctx.hideContribsSection]
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link text-dark text-decoration-none me-md-2",
        "aria-label": "Close",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancel-pots-edit')))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "button",
        class: "btn px-5 btn-secondary",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSaveClicked && _ctx.onSaveClicked(...args)))
      }, _toDisplayString(_ctx.buttonText), 1)
    ])
  ], 64))
}